/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_Title_ColInputs */

const en_admin_permissions_title_col = /** @type {(inputs: Admin_Permissions_Title_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

const zh_admin_permissions_title_col = /** @type {(inputs: Admin_Permissions_Title_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题`)
};

/**
* | output |
* | --- |
* | "Title" |
*
* @param {Admin_Permissions_Title_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_permissions_title_col = /** @type {((inputs?: Admin_Permissions_Title_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_Title_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_permissions_title_col(inputs)
	return zh_admin_permissions_title_col(inputs)
});
export { admin_permissions_title_col as "admin.permissions.title_col" }